import { render } from "./HiProgressRing.vue?vue&type=template&id=18a22cc1&scoped=true"
import script from "./HiProgressRing.vue?vue&type=script&lang=js"
export * from "./HiProgressRing.vue?vue&type=script&lang=js"

import "./HiProgressRing.vue?vue&type=style&index=0&id=18a22cc1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a22cc1"]])

export default __exports__